export const THEME_COOKIE = "swift_theme";
export const THEME_VALUES = ["light", "dark", "system"] as const;
export type ThemeValue = (typeof THEME_VALUES)[number];

export function isThemeValue(v: unknown): v is ThemeValue {
  return typeof v === "string" && (THEME_VALUES as readonly string[]).includes(v);
}
